import React from 'react';

import {
  Alert,
  Box,
  Chip,
  Stack,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';
import DetailTemplate from '../../common/template/DetailTemplate';
import OrderBookSummary from './OrderBookSummary';
import OrderBookFormContainer from '../../../containers/chancemng/obtainorder/OrderBookFormContainer';
import OrderProductListContainer from '../../../containers/chancemng/obtainorder/OrderProductListContainer';
import OrderBookApprovalContainer from '../../../containers/chancemng/obtainorder/OrderBookApprovalContainer';
import OrderBookInfoContainer from '../../../containers/chancemng/obtainorder/OrderBookInfoContainer';
import SalesProfitFormContainer from '../../../containers/chancemng/obtainorder/SalesProfitFormContainer';
import SalesProfitInfoContainer from '../../../containers/chancemng/obtainorder/SalesProfitInfoContainer';
import OrderBookFileListContainer from '../../../containers/chancemng/obtainorder/OrderBookFileListContainer';
import { getNumberComma } from '../../../utils/numberUtils';

import OrderBillListContainer from '../../../containers/chancemng/obtainorder/OrderBillListContainer';
import OrderCompanyBillListContainer from '../../../containers/chancemng/obtainorder/OrderCompanyBillListContainer';

import ProjectFileListContainer from '../../../containers/techmng/files/ProjectFileListContainer';
import ApprovalV2HistoryPanel from '../../common/approval/ApprovalV2HistoryPanel';
import OrderApprovalV2Form from '../../projectmng/obtainorder/OrderApprovalV2Form';


const OrderBookModal = ({
  chance,
  lineId,
  approvalSteps,
  approvalLines,
  approvalLineLoading,
  currentUserUuid,
  approvalStepsError,
  setLineId,
  setApprovalSteps,
  approvalList,
  approvalV2Doc,
  approvalV2Steps,
  approvalV2Actions,
  finalApprovalAvailable,
  finalApprovalYn,
  finalApprovalComment,
  setFinalApprovalYn,
  setFinalApprovalComment,
  roUuid,
  user,
  type,
  open,
  handleClose,
  formik,
  orderInfo,
  scollToRef,
  onDeleteApproval,
}) => {
  const showApprovalEditor = type === 'add'
    || (type === 'edit' && orderInfo?.crtUsr === user?.usrUuid && orderInfo?.ordYn === 'S');

  const showApprovalV2History = Boolean(approvalV2Doc);

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      fullScreen
      fullWidth={true}
    >
      <BootstrapDialogTitle onClose={handleClose}>
        수주품의서
      </BootstrapDialogTitle>

      <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
        <DialogContent
          dividers
          sx={{
            height: '80vh',
            overflowY: 'auto',
          }}
        >
          {orderInfo?.ordYn === 'S' && user?.usrUuid === orderInfo?.crtUsr && (
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{ my: 1 }}
            >
              <Button
                variant="contained"
                color="error"
                onClick={onDeleteApproval}
              >
                결재 삭제
              </Button>
            </Stack>
          )}
          {type === 'edit' && (
            <DetailTemplate title="개요">
              <OrderBookSummary
                orderInfo={orderInfo}
                approvalList={approvalList}
                approvalV2Doc={approvalV2Doc}
              />
            </DetailTemplate>
          )}

          <div ref={scollToRef}></div>
          <DetailTemplate title="기본사항">
            {type === 'edit' && orderInfo?.ordYn !== 'S' ? (
              <OrderBookInfoContainer orderInfo={orderInfo} chance={chance} />
            ) : (
              <OrderBookFormContainer
                type={type}
                formik={formik}
                chance={chance}
                orderInfo={orderInfo}
              />
            )}
          </DetailTemplate>
{/* 
          {type === 'edit' && (
            <DetailTemplate title="수주품의서 파일 리스트">
              <OrderBookFileListContainer orderInfo={orderInfo} />
            </DetailTemplate>
          )} */}
 {type !== 'add' && (
        <DetailTemplate title={`영업파일`}>
          <ProjectFileListContainer />
        </DetailTemplate>
 )}
          {/* <DetailTemplate title={`최종 매출 이익 (내부거래 포함)`}>
            {type === 'edit' && orderInfo?.ordYn !== 'S' ? (
              <SalesProfitInfoContainer orderInfo={orderInfo} chance={chance} />
            ) : (
              <SalesProfitFormContainer
                formik={formik}
                chance={chance}
                orderInfo={orderInfo}
              />
            )}
          </DetailTemplate> */}

          {showApprovalEditor && (
            <DetailTemplate title="approval v2 결재선">
              <Box sx={{maxHeight: '300px', overflowY: 'auto'}}>
                <OrderApprovalV2Form
                  approvalLines={approvalLines}
                  approvalLineLoading={approvalLineLoading}
                  lineId={lineId}
                  approvalSteps={approvalSteps}
                  currentUserUuid={currentUserUuid}
                  approvalStepsError={approvalStepsError}
                  finalApprovalAvailable={finalApprovalAvailable}
                  finalApprovalYn={finalApprovalYn}
                  finalApprovalComment={finalApprovalComment}
                  onFinalApprovalYnChange={setFinalApprovalYn}
                  onFinalApprovalCommentChange={setFinalApprovalComment}
                  onApprovalLineChange={setLineId}
                  onApprovalStepsChange={setApprovalSteps}
                />
              </Box>
            </DetailTemplate>
          )}

          {type === 'edit' && (
            <DetailTemplate title="결재 내역">
              {showApprovalV2History ? (
                <Stack spacing={2}>
                  <Alert severity="info">
                    approval v2 문서번호: {approvalV2Doc.refDocNo || '-'} / 현재 결재자: {approvalV2Doc.currentActorNm || '-'}
                  </Alert>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2" color="text.secondary">상태</Typography>
                    <Chip
                      size="small"
                      label={approvalV2Doc.docStatus || '-'}
                      color={approvalV2Doc.docStatus === 'APPROVED' ? 'success' : approvalV2Doc.docStatus === 'REJECTED' ? 'error' : 'warning'}
                    />
                  </Stack>
                  <ApprovalV2HistoryPanel steps={approvalV2Steps || []} actions={approvalV2Actions || []} />
                </Stack>
              ) : (
                <OrderBookApprovalContainer approvalList={approvalList} />
              )}
            </DetailTemplate>
          )}

          <DetailTemplate title="원가산출 내역">
            <OrderProductListContainer />
          </DetailTemplate>

          <DetailTemplate title="거래처별 매출/매입 내역">
            <OrderCompanyBillListContainer 
              chance={chance} 
              roUuid={orderInfo?.roUuid ? orderInfo?.roUuid : null} 
              mode={type}
            />
          </DetailTemplate>

        </DialogContent>
        <DialogActions>
          {type === 'add' ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                m: 1,
              }}
            >
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={formik.isSubmitting}
              >
                수주품의서 저장
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                m: 1,
              }}
            >
              <Box>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  disabled={orderInfo?.ordYn !== 'S' || formik.isSubmitting}
                >
                  수주품의서 저장
                </Button>
              </Box>
            </Box>
          )}
        </DialogActions>
      </form>
    </BootstrapDialog>
  );
};

export default OrderBookModal;
